import React from 'react';
import { Flex, Margin, BadgeWrapper } from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';
import Text from 'components/base/Text';

const GoalCol = ({ name, chartName, isNew = false, widgetId }) => {
  return (
    <Flex items='center'>
      <Flex direction='column'>
        <Text size='medium' id={`highlight-${widgetId}`}>
          {name}
        </Text>
        {/* Text id to auto-scroll to element if redirected from TeamGoals page*/}
        {chartName && (
          <Text size='small' color='osloGray' pt={SPACES['x-small']}>
            {chartName}
          </Text>
        )}
      </Flex>
      {isNew && (
        <Margin l='normal'>
          <BadgeWrapper isNotAbsolute={true}>New!</BadgeWrapper>
        </Margin>
      )}
    </Flex>
  );
};

export default GoalCol;
